import ResetPassword  from './ResetPassword';

export default ResetPassword;


// WEBPACK FOOTER //
// ./src/app/views/admin/resetPassword/index.js